export const UPDATE_CREDIT_NOTE_STATUS = gql`
    mutation updateCreditNoteStatus($input: UpdateCreditNoteStatusInput!) {
        updateCreditNoteStatus(input: $input) {
            message
        }
    }
`;
